require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuung-10-14-betreuungseinrichtungen-mattersburg-sieggraben.json") })
        }
      }, "path---betreuung-10-14-betreuungseinrichtungen-mattersburg-sieggraben");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuung-10-14-betreuungseinrichtungen-mattersburg-sieggraben!./.cache/json/betreuung-10-14-betreuungseinrichtungen-mattersburg-sieggraben.json
// module id = 753
// module chunks = 231608221292675